var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___WTV1Sm",
  "k3": "GuildBadge.module__badgeRow___WTV1Sm",
  "ZY": "GuildBadge.module__customBadge___WTV1Sm",
  "uk": "GuildBadge.module__customBadgeTooltip___WTV1Sm",
  "n6": "GuildBadge.module__customBadgeTooltipName___WTV1Sm",
  "qS": "GuildBadge.module__badge___WTV1Sm",
  "eT": "GuildBadge.module__badgeOnLightSurface___WTV1Sm",
  "YW": "GuildBadge.module__badgeBanner___WTV1Sm",
  "e$": "GuildBadge.module__badgeBannerDark___WTV1Sm",
  "D_": "GuildBadge.module__morePill___WTV1Sm",
};

module.exports = exports;
